import type { AllocationChangedEventData, BillChangedEventData, IdentityChangedEventData } from "@/data/events/events";
import type { ICustomerCart } from "@/data/model/Customer";
import { Signal, TypedSignal } from "@/data/util/Signal";

export type CartUpdatedEventData = {
    cart: ICustomerCart;
    updateHash: string;
};

export const appEvents = {
    // app context events
    appContext: {
        OrderChanged: new TypedSignal<string>(),
        ItemSelectionChanged: new TypedSignal<string>(),
        AllocationChanged: new TypedSignal<AllocationChangedEventData>(),
        BillChanged: new TypedSignal<BillChangedEventData>(),
        GuestNumberChanged: new TypedSignal<string>(),
        OfferChanged: new Signal(),
        SelectedServiceChanged: new Signal(),
        OfferLoadingStarted: new Signal(),
    },
    controller: {
        hidden: new Signal(),
        shown: new TypedSignal<string>(),
    },
    identity: {
        identityChanged: new TypedSignal<IdentityChangedEventData>(),
    },
    tastierClient: {
        initialized: new Signal(),
    },
    cartController: {
        cartUpdated: new TypedSignal<CartUpdatedEventData>(),
    },
};
